import React from 'react';
const companies = [{
  name: 'DoorDash',
  logo: 'https://cdn.magicpatterns.com/uploads/anfjnKVP269cYHU5qxQS2k/DoorDash_Logo.svg.png'
}, {
  name: 'Whatnot',
  logo: 'https://cdn.magicpatterns.com/uploads/tmqnQZJLsrAH2FJMnZtSb9/Whatnot_Logo_2025.svg.png'
}, {
  name: 'Clay',
  logo: 'https://cdn.magicpatterns.com/uploads/jBmrAaM5BuFQEM4ihdQqDJ/Clay-Logo-Light-1024x548.png'
}, {
  name: 'JLL',
  logo: 'https://cdn.magicpatterns.com/uploads/o1aBNzghZtL5UC7oFNV1HZ/JLL_logo.svg-2.png'
}, {
  name: 'Alibaba',
  logo: 'https://cdn.magicpatterns.com/uploads/hxfPEtMS8Xy75fyirjy1B4/Alibaba.com-logo-1.png'
}];
export function TrustBar() {
  const tickerItems = [...companies, ...companies, ...companies];
  return <div className="w-full bg-white py-20 overflow-hidden relative flex flex-col items-center" data-id="element-4168">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full relative flex items-center overflow-hidden" data-id="element-4169">
        <div className="flex w-max animate-ticker" data-id="element-4170">
          {tickerItems.map((company, index) => <div key={index} className="flex items-center justify-center px-16" data-id="element-4171">
              <img src={company.logo} alt={`${company.name} logo`} className="h-8 max-w-[160px] object-contain opacity-50 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-300" data-id="element-4172" />
            </div>)}
        </div>
      </div>
    </div>;
}